module.exports = __webpack_public_path__ + "static/img/idcardb.2d0dc97.png";


//////////////////
// WEBPACK FOOTER
// ./src/summary/assets/images/idcardb.png
// module id = GH2m
// module chunks = 166